import InputSearch from './input-search.vue'

export default {
    install: function(Vue) {
        Vue.component('InputSearch', InputSearch)
    }
}